import { useQuery } from "@apollo/react-hooks";

import { QueryLearnerArgs } from "@hubcapp/types";
import testDetails from "../graph-ql/testDetails.graphql";

const useQueryTestDetails = (
  instructorId: string,
  id?: QueryLearnerArgs["id"],
) =>
  useQuery(testDetails, {
    skip: !id,
    variables: {
      id,
      instructorId,
    },
  });

export default useQueryTestDetails;
